/* scrollPageToTop — put the page back at the top so TabBar is the first thing on screen.
 *
 * React Router's navigate() keeps the current window offset. ProfileHome is a long page
 * (videos, accordion, map, log out), so a tile tapped near the bottom — or a FooterNav tap
 * from deep inside a form — used to open the next route already scrolled past TabBar.
 *
 * Resets the window plus every scrolling ancestor of `el` (the InnerTabs content panel on
 * mobile scrolls inside its own div). Runs now and again after the next paint: iOS Safari
 * ignores the first call while the address bar is still resizing.
 */
export default function scrollPageToTop(el) {
  const run = () => {
    if (typeof window === 'undefined') return;
    window.scrollTo(0, 0);
    const root = document.scrollingElement || document.documentElement;
    if (root && root.scrollTop) root.scrollTop = 0;
    if (document.body && document.body.scrollTop) document.body.scrollTop = 0;
    let node = el ? el.parentElement : null;
    while (node && node !== document.body) {
      if (node.scrollTop) node.scrollTop = 0;
      node = node.parentElement;
    }
  };
  run();
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
}
